import { createContext, useContext } from "react";
import type { MobileHomeSegment } from "@/react/types/MobileHomeSegment";

interface MobileHomeSegmentsContextValue {
  orderedMobileHomeSegments: MobileHomeSegment[];
  setOrderedMobileHomeSegments: (segments: MobileHomeSegment[]) => void;
}

const MobileHomeSegmentsContext = createContext<MobileHomeSegmentsContextValue>(
  { orderedMobileHomeSegments: [], setOrderedMobileHomeSegments: () => {} },
);
MobileHomeSegmentsContext.displayName = "MobileHomeSegmentsContext";

interface MobileHomeSegmentsProviderProps {
  children: React.ReactNode;
  orderedMobileHomeSegments: MobileHomeSegment[];
  setOrderedMobileHomeSegments: (segments: MobileHomeSegment[]) => void;
}
export const MobileHomeSegmentsProvider = ({
  orderedMobileHomeSegments,
  setOrderedMobileHomeSegments,
  children,
}: MobileHomeSegmentsProviderProps) => (
  <MobileHomeSegmentsContext.Provider
    value={{ orderedMobileHomeSegments, setOrderedMobileHomeSegments }}
  >
    {children}
  </MobileHomeSegmentsContext.Provider>
);

export const useMobileHomeSegmentsContext = () =>
  useContext(MobileHomeSegmentsContext);
